import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "36",
  height: "44",
  viewBox: "0 0 36 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M4.9974 0.333008C2.61406 0.333008 0.68573 2.28301 0.68573 4.66634L0.664062 39.333C0.664062 41.7163 2.5924 43.6663 4.97573 43.6663H30.9974C33.3807 43.6663 35.3307 41.7163 35.3307 39.333V13.333L22.3307 0.333008H4.9974ZM20.1641 15.4997V3.58301L32.0807 15.4997H20.1641Z",
  fill: "#F2C05E"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };